import {Platform} from 'react-native';

export const getEsiaOAuthParams = (search: string) => {
  const params = new URLSearchParams(search);
  const code = params.get('code');
  const state = params.get('state');
  return !params.has('op') && code && state ? {code, state} : null;
};

export const hasEsiaOAuthParams = () => {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return false;
  return Boolean(getEsiaOAuthParams(window.location.search));
};
